module.exports = __webpack_public_path__ + "static/img/gzh.848caf74.jpg";